import React           from 'react';
import PropTypes       from 'prop-types';

import { generateKey } from '../../../utils/CommonUtils';
import Translations    from '../../../utils/Translations';

const Awards = ({awards}) => {

    if(awards.length === 0) {
        return null;
    }

    const actorAwards = awards?.map((award, index) => {
        const awardContent = (
            <div
                className="context-box__tile--award"
                data-tip={`${award.tooltip ? Translations.get(award.tooltip) : ''}`}
            >
                {award.iconClass &&
                    <span className={`context-box__tile--award__icon icon-actor ${award.iconClass}`}/>
                }
                {award.headline &&
                    <span className={`context-box__tile--award__headline ${award.subline ? '' : '-no-subline'}`}>
                        {Translations.get(award.headline)}
                    </span>
                }
                {award.subline &&
                    <span className="context-box__tile--award__subline">
                        {Translations.get(award.subline)}
                    </span>
                }
            </div>
        );

        return (
            <div
                key={generateKey(award.iconClass, index)}
                className="col-xs-2"
            >
                {award.targetUrl
                 ? <a href={award.targetUrl}>
                        {awardContent}
                   </a>
                 : awardContent
                }
            </div>
        );
    });

    return (
        <section className="container-block -margin-bottom-lg row">
            <div className="col-xs-12 col-lg-4">
                <div className="context-box -no-padding hidden-md-down">
                    <p
                        className="context-box__title--award"
                        dangerouslySetInnerHTML={{__html: Translations.get('actor_profile.about_me-awards.title')}}
                    />
                </div>
                <div className="context-box--actor-profile hidden-lg-up">
                    <p
                        className="context-box__title"
                        dangerouslySetInnerHTML={{__html: Translations.get('actor_profile.about_me-awards.title')}}
                    />
                </div>
            </div>
            <div className="col-xs-12 col-lg-8">
                <div className="context-box--actor-profile -padding-awards-tiles row">
                    {actorAwards}
                </div>
            </div>
        </section>
    );
};

Awards.propTypes = {
    awards: PropTypes.arrayOf(PropTypes.shape({
        iconClass: PropTypes.string,
        headline:  PropTypes.string,
        subline:   PropTypes.string,
        targetUrl: PropTypes.string,
        tooltip:   PropTypes.string,
    }))
};

export default Awards;
